var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.133 5.329H9.072V4.063a.618.618 0 0 1 .178-.524.725.725 0 0 1 .548-.208l2.143.006V.667H8.836c-2.817 0-3.35 1.98-3.35 3.233V5.33H3.333v2.664h2.151v7.34H9.072v-7.34h2.762l.3-2.664Z",
    fill: "#fff"
  })));
};
export default SvgIconFacebook;